'use client';

import { __resetStyles, mergeClasses } from "@griffel/react";
export const listClassNames = {
  root: 'fui-List'
};
const useRootBaseStyles = /*#__PURE__*/__resetStyles("r1m6yby2", null, [".r1m6yby2{padding:0;margin:0;text-indent:0;list-style-type:none;}"]);
/**
 * Apply styling to the List slots based on the state
 */
export const useListStyles_unstable = state => {
  const rootStyles = useRootBaseStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(listClassNames.root, rootStyles, state.root.className);
  return state;
};